import { h, Component } from "preact";

import Image from "../../Image";
import Button from "../../buttons/Button";
import Card from "../card/Card";

import styles from "./cardSlider.scss";

const CardSlider = ({ title, link = "#", cards }) => (
  <div className={styles.content}>
    <h2 className={styles.heading}>{title}</h2>
    <div className={styles.wrapper}>
      {cards.map(function(item, index) {
        return (
          <div className={styles.block}>
            <Card
              image={item.image}
              title={item.title}
              time={item.time}
              location={item.location}
              priceString={item.priceString}
              link={item.link}
              dates={item.dates}
            />
          </div>
        );
      })}
    </div>
    <div className={styles.button}>
      <a href={link} aria-label="See more events">
        <Button aria="See More" ariaHidden>
          See More
        </Button>
      </a>
    </div>
  </div>
);

export default CardSlider;
